export const DefaultPendingComponent: React.FC = () => {
  return (
    <div role="status" aria-live="polite" className="flex min-h-[50vh] items-center justify-center">
      <span
        aria-hidden="true"
        className="size-10 animate-spin rounded-full border-4 border-primary border-t-brand-yellow motion-reduce:animate-pulse"
      />
      <span className="sr-only">Loading…</span>
    </div>
  );
};
